import { apiSlice } from './apiSlice';
import { AGENCY_URL } from '../constants';

export const agencyAuthApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    agencyLogin: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/auth`,
        method: 'POST',
        body: data, // { email, password }
      }),
    }),

    // Step 2 of login: submit the 6-digit code emailed to the agency.
    // On success the backend issues the real agencyJwt + CSRF cookies and
    // returns the same user-info shape agencyLogin used to return directly.
    agencyVerifyOtp: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/verify-otp`,
        method: 'POST',
        body: data, // { email, otp }
      }),
    }),

    agencyLogout: builder.mutation({
      query: () => ({
        url: `${AGENCY_URL}/logout`,
        method: 'POST',
      }),
    }),

    agencyRequestPasswordReset: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/preset`,
        method: 'POST',
        body: data, // { email }
      }),
    }),

    // Step 2 of password reset: submit the 6-digit code emailed to the
    // agency. On success the backend opens a short-lived reset session (the
    // httpOnly `pset` cookie) — no resetToken is ever returned in the body.
    agencyVerifyPasswordResetOtp: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/verify-reset-otp`,
        method: 'POST',
        body: data, // { email, otp }
      }),
    }),

    agencyResetPassword: builder.mutation({
      query: (data) => ({
        url: `${AGENCY_URL}/resetpass`,
        method: 'POST',
        body: data, // { email, password } — resetToken comes from the pset cookie, not the body
      }),
    }),
  }),
});

export const {
  useAgencyLoginMutation,
  useAgencyVerifyOtpMutation,
  useAgencyLogoutMutation,
  useAgencyRequestPasswordResetMutation,
  useAgencyVerifyPasswordResetOtpMutation,
  useAgencyResetPasswordMutation,
} = agencyAuthApiSlice;
